import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import BasePackageForm from '../BasePackageForm'

const MusicPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.musicpackages.createPackage'}>
    <Create>
      <BasePackageForm entity="musics" />
    </Create>
  </SectionWrapper>
)

export default MusicPackageCreate
